import styled from 'styled-components';
import { Color } from '../Globals/Globals';

interface IPill {
  color?: string;
  background?: string;
  fontSize?: number;
}

export const Pill = styled.span<IPill>`
  background: ${props => (props.background ? props.background : Color.white)};
  color: ${props => (props.color ? props.color : Color.darkBlue)};
  border: 1px solid ${props => (props.color ? props.color : Color.darkBlue)};
  font-size: ${props => (props.fontSize ? props.fontSize : 'smaller')};
  padding: 5px 10px;
  height: fit-content;
  border-radius: 20px;
  font-weight: 600;
  margin-right: 5px;
  height: 15px;
  background: none;
  flex-shrink: 0;
`;



// WEBPACK FOOTER //
// ./src/components/Pill/Pill.tsx